import { Component, effect, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../../shared/header/header.component';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from '../../shared/sidebar/sidebar.component';
import { MatDialog } from '@angular/material/dialog';
import { NoticePopupAdminComponent } from '../../features/notice/notice-popup-admin/notice-popup-admin.component';
import { NoticeBoard } from '../../core/service/notice/notice.service';
import { Subject, takeUntil } from 'rxjs';
import { LocalStorageService } from '../../core/service/localStorage/local-storage.service';
import { SidebarCollapseService } from '../../core/service/layout/sidebar-collapse.service';
import { CrizacAssistComponent } from '../../shared/crizac-assist/crizac-assist.component';
@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [CommonModule, RouterModule, HeaderComponent, SidebarComponent, CrizacAssistComponent],
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent {

  public unsubscribeAll: Subject<any> = new Subject()
  userDetails: any
  noticeGet: any[] = []
  isActive = false;
  public readonly dialogRef = inject(MatDialog);
  private readonly noticeService = inject(NoticeBoard)
  readonly localStorageService = inject(LocalStorageService);
  count: number = 0;
  isSwitchUser: boolean = false;
  tenent:any
  // async ngOnInit():Promise<void>{
  //   this.isSwitchUser = JSON.parse(
  //     this.localStorageService.getKey('isSwitchUser') || 'false'
  //   );
  //   this.userDetails = await this.localStorageService.getKeyIndexedDbKey(
  //     'currentUser'
  //   );
  //   console.log(this.userDetails);

  //   this.getNotice()
  // }
  async ngOnInit(): Promise<void> {
    const switchUserValue =
      await this.localStorageService.getKeyIndexedDbKey('switchUser');
    this.isSwitchUser = !!switchUserValue;
    this.userDetails =
      await this.localStorageService.getKeyIndexedDbKey('currentUser');
    this.tenent = this.userDetails?.roles[0]?.tenant.join(',')  
    if (this.isSwitchUser) {
      return;
    }

    if (this.userDetails?.noticeHideShow === 'true') {
      this.getNotice();
    }
  }


  /**
   * The rail's collapsed state is mirrored from `SidebarCollapseService` so a
   * child of this layout can close it too — "Search Program" does, on the way
   * in. The hamburger stays the primary control and writes through the same
   * service, which keeps the two in step instead of fighting.
   */
  private readonly sidebarCollapse = inject(SidebarCollapseService);
  private readonly syncCollapse = effect(() => {
    this.isActive = this.sidebarCollapse.collapsed();
  });

  hamburgerToggleDiv() {
    this.sidebarCollapse.toggle();
  }

  getNotice() {
    this.noticeService.getNoticePopUp('bdayNotice,featureNotice,adminNotification,universityRequrement', this.userDetails.jobRoleId, true,this.tenent).pipe(takeUntil(this.unsubscribeAll)).subscribe(
      (res) => {
        const noticeGet = res?.data?.data
        if (noticeGet?.length && noticeGet.length > 0) {
          this.noticeGet = noticeGet.slice(0, 3)
          this.noticepopUp()
        }
      }
    )
  }
  noticepopUp() {
    if (this.isSwitchUser) {
      return; // 🚫 hard stop
    }
    if (this.count < this.noticeGet.length) {
      const particularDetails = this.noticeGet[this.count]
      const obj = {
        description: particularDetails.description,
        imagePath: particularDetails.imagePath,
        noticeid: particularDetails.id,
        title: particularDetails.title,
        count: this.count,
        universityName: particularDetails?.universityDetails?.join(', ') ?? '',
        universityCountryDetails: particularDetails?.universityCountryDetails?.name,
        intakeDetails: particularDetails?.intakeDetails?.join(', ') ?? ''
      };
      this.dialogRef.open(NoticePopupAdminComponent, {
        width: '90vw',
        enterAnimationDuration: '500ms',
        exitAnimationDuration: '500ms',
        disableClose: true,
        data: obj
      }).afterClosed().subscribe((res: any) => {
        this.count++
        setTimeout(
          () => {
            this.noticepopUp()
          }, 5000
        )
      })
    }
  }

}
